export const home = (usersCount, ordersCount, uniqueUsersCount, revenue) => [
  { label: "Users", value: usersCount, color: "#009efa" },
  { label: "Orders this month", value: ordersCount, color: "#7260ed" },
  {
    label: "Unique users this month",
    value: uniqueUsersCount,
    color: "#56ce66",
  },
  { label: "Revenue this month", value: "$ " + revenue, color: "#ffbc36" },
];
